import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import CusInput from '../../../../components/material-ui/CusInput';
import CusButton from '../../../../components/material-ui/CusButton';
import { useTranslation } from 'react-i18next';
import { API_USERS } from '../../../../api/users';
import CusTooltip from '../../../../components/material-ui/CusTooltip';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';

export default function DepositAdd({ userId, currency, updateInfo }) {
  const { t } = useTranslation();
  const [amount, setAmount] = useState('');
  const [wager, setWager] = useState('');
  const { isMobile, isTablet } = useBootstrapSize();

  const onAddClick = () => {
    API_USERS.info.balances
      .append({ userId, currency, amount, wager })
      .then((e) => {
        setAmount('');
        setWager('');
        updateInfo();
      })
      .catch(console.error());
  };

  return (
    <Stack direction={isTablet || isMobile ? 'column' : 'row'} mt={2} gap={2} alignItems={'center'}>
      <Stack width={isTablet ? '100%' : 200} direction={'row'} gap={0.5}>
        <Typography>
          {t('Add deposit')}, {!isMobile ? currency : ''}
        </Typography>
        <CusTooltip text={"If wager is 0, the method tops up the user's main balance"} />
      </Stack>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        gap={1}
        flex={1}
        width={isTablet || isMobile ? '100%' : 'auto '}>
        <CusInput
          hideArrows
          type="number"
          label={isMobile ? currency : ''}
          value={String(+amount)}
          inputProps={{ min: 1 }}
          width={isMobile ? 'grow' : 'auto'}
          inputSx={{ maxWidth: isMobile ? '100%' : '150px' }}
          onChange={(e) => setAmount(+e.target.value)}
        />

        <CusInput
          hideArrows
          type="number"
          label={'Wager'}
          isRow={!isMobile}
          value={String(+wager)}
          inputProps={{ min: 0 }}
          width={isMobile ? 'grow' : 'auto'}
          inputSx={{ maxWidth: isMobile ? '100%' : '150px' }}
          onChange={(e) => setWager(+e.target.value)}
        />

        <CusButton
          sx={isMobile ? {} : { marginLeft: 'auto' }}
          boxProps={isMobile ? {} : { ml: 'auto' }}
          text="Add deposit"
          onClick={onAddClick}
          disabled={!amount}
          fullWidth={isMobile}
        />
      </Stack>
    </Stack>
  );
}
